import React, {useState} from 'react';

const CardItem = ({cardImg, cashPerDay, cashAccured}) => {
    const [staked, setStaked] = useState(false);

    const numberWithDots = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    return (
        <div className="flex justify-self-center gap-1 flex-col font-gilroy w-[300px]">
            <img className="rounded-[15px]" src={cardImg} alt="nft_card" width={300}/>
            <div
                className="bg-white gap-2 flex flex-col rounded-[15px] text-black text-[15px] font-semibold px-3 normal-case py-4">
                <div className="flex justify-between">
                    <p className="opacity-70">Speed Cash per day</p>
                    <span>{numberWithDots(cashPerDay)}</span>
                </div>
                <div className="flex justify-between">
                    <p className="opacity-70">Speed Cash ACCURED</p>
                    <span>{numberWithDots(cashAccured)}</span>
                </div>
                <div
                    className={`mt-[10px] bg-[${staked ? "#F155FF" : "#5599FF"}] cursor-pointer w-100 flex place-items-center justify-center rounded-[10px]`}
                    onClick={() => {
                        setStaked(!staked)
                    }}>
                    <p className="text-white py-[10px]">{staked ? "Unstake" : "Stake"}</p>
                </div>
            </div>
        </div>
    );
};

export default CardItem;